import { render, staticRenderFns } from "./WorkBenefits.vue?vue&type=template&id=1125087e&scoped=true&"
import script from "./WorkBenefits.vue?vue&type=script&lang=js&"
export * from "./WorkBenefits.vue?vue&type=script&lang=js&"
import style0 from "./WorkBenefits.vue?vue&type=style&index=0&id=1125087e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1125087e",
  null
  
)

export default component.exports